import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'h1, h2, h3, h4, h5, h6': {
          margin: 0,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          marginBottom: '1rem',
        },
        h2: {
          marginBottom: '2rem',
          marginTop: '2rem',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          '@media print': {
            boxShadow: 'none',
          },
        },
      },
    },
  },
  palette: {
    primary: {
      main: '#81216a',
      light: '#a14d8c',
    },
    secondary: {
      main: '#2c3e50',
      light: '#34495e',
      dark: '#2c3e50',
    },
    error: {
      main: '#dc2626',
    },
    warning: {
      main: '#f59e0b',
    },
    success: {
      main: '#27ae60',
    },
    background: {
      default: '#ffffff',
      paper: '#f8f9fa',
    },
    info: {
      main: '#3b82f6',
    },
    text: {
      primary: '#2c3e50',
      secondary: '#64748b',
    },
  },
  typography: {
    fontFamily: '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
    h1: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '2.5rem',
      color: '#81216a',
    },
    h2: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '2rem',
      color: '#81216a',
    },
    h3: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '1.75rem',
      color: '#81216a',
    },
    h4: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '1.5rem',
      color: '#81216a',
    },
    h5: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '1.25rem',
      color: '#81216a',
    },
    h6: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '1rem',
      color: '#81216a',
    },
    body1: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '1rem',
      lineHeight: 1.6,
    },
    body2: {
      fontFamily: '"Geist", sans-serif',
      fontWeight: 300,
      fontSize: '0.875rem',
      lineHeight: 1.6,
    },
  },
}); 